import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { formatPublicMoney } from './helpers';
import { AvatarSmall } from '../../components';
import css from './ListingPage.module.css';
import classNames from 'classnames';

const BidHistoryTab = ({ bidsToRender, currentUser, intl }) => {
  const hasBids = bidsToRender.length > 0;
  return (
    <div className={css.tastingNotes}>
      <h2>
        <FormattedMessage id="ListingPage.recentActivity.title" defaultMessage="Recent Activity" />
      </h2>

      {hasBids ? (
        <div className={css.activityTable}>
          <table>
            <thead>
              <tr>
                <th>
                  <FormattedMessage
                    id="ListingPage.recentActivity.bidder"
                    defaultMessage="Bidder"
                  />
                </th>
                <th>
                  <FormattedMessage id="ListingPage.recentActivity.date" defaultMessage="Date" />
                </th>
                <th>
                  <FormattedMessage
                    id="ListingPage.recentActivity.amount"
                    defaultMessage="Amount"
                  />
                </th>
                <th>
                  <FormattedMessage
                    id="ListingPage.recentActivity.status"
                    defaultMessage="Status"
                  />
                </th>
              </tr>
            </thead>

            <tbody>
              {bidsToRender.map(b => {
                const isMe = !!b?.isCurrentUser;
                const rowClass = isMe ? css.current : '';
                const statusClass = b?.isHighest ? classNames(css.status, css.lending) : css.status;

                const amountLabel =
                  b?.amount?.amount != null && b?.amount?.currency
                    ? formatPublicMoney(b.amount, intl)
                    : b?.amountText || '-';

                return (
                  <tr key={b.transactionId} className={rowClass}>
                    <td className={isMe ? '' : css.activityTitle}>
                      {isMe ? (
                        <div className={css.user}>
                          <AvatarSmall user={currentUser} />
                          <FormattedMessage
                            id="ListingPage.recentActivity.you"
                            defaultMessage="You"
                          />
                        </div>
                      ) : (
                        b?.bidderLabel || '-'
                      )}
                    </td>

                    <td title={b?.timeFullLabel || '-'}>{b?.timeLabel || '-'}</td>
                    <td className={css.price}>{amountLabel}</td>

                    <td className={statusClass}>
                      {b?.isHighest ? (
                        <FormattedMessage
                          id="ListingPage.recentActivity.highest"
                          defaultMessage="Highest"
                        />
                      ) : (
                        '-'
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ) : (
        <div className={css.emptyBidHistory}>
          <FormattedMessage
            id="ListingPage.recentActivity.empty"
            defaultMessage="No bids yet. Be the first to place a bid."
          />
        </div>
      )}
    </div>
  );
};

export default BidHistoryTab;
